__turbopack_context__.v({
  "arrowButtonsRegion": "DiscoveryTabbedCarousel-module__NJooza__arrowButtonsRegion",
  "carouselContainer": "DiscoveryTabbedCarousel-module__NJooza__carouselContainer",
  "carouselRoot": "DiscoveryTabbedCarousel-module__NJooza__carouselRoot",
  "carouselSection": "DiscoveryTabbedCarousel-module__NJooza__carouselSection",
  "carouselSlide": "DiscoveryTabbedCarousel-module__NJooza__carouselSlide",
  "carouselTrack": "DiscoveryTabbedCarousel-module__NJooza__carouselTrack",
  "carouselViewport": "DiscoveryTabbedCarousel-module__NJooza__carouselViewport",
  "eyebrow": "DiscoveryTabbedCarousel-module__NJooza__eyebrow",
  "mobileArrowButtonsRegion": "DiscoveryTabbedCarousel-module__NJooza__mobileArrowButtonsRegion",
  "pinnedBreadcrumbs": "DiscoveryTabbedCarousel-module__NJooza__pinnedBreadcrumbs",
  "sectionTitleRegion": "DiscoveryTabbedCarousel-module__NJooza__sectionTitleRegion",
  "sectionTitleText": "DiscoveryTabbedCarousel-module__NJooza__sectionTitleText",
  "sectionTitleTextRegion": "DiscoveryTabbedCarousel-module__NJooza__sectionTitleTextRegion",
  "slideBody": "DiscoveryTabbedCarousel-module__NJooza__slideBody",
  "slideImage": "DiscoveryTabbedCarousel-module__NJooza__slideImage",
  "slideStage": "DiscoveryTabbedCarousel-module__NJooza__slideStage",
  "slideTestimonialCard": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialCard",
  "slideTestimonialContent": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialContent",
  "slideTestimonialDot": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialDot",
  "slideTestimonialDotsEnd": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialDotsEnd",
  "slideTestimonialDotsStart": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialDotsStart",
  "slideTestimonialImages": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialImages",
  "slideTestimonialSource": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialSource",
  "slideTestimonialStat": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialStat",
  "slideTestimonialStatDescription": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialStatDescription",
  "slideTestimonialStatValue": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialStatValue",
  "slideTestimonialStats": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialStats",
  "slideTestimonialTextList": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialTextList",
  "slideTitleBlock": "DiscoveryTabbedCarousel-module__NJooza__slideTitleBlock",
  "slideTitleRegion": "DiscoveryTabbedCarousel-module__NJooza__slideTitleRegion",
  "slideTitleText": "DiscoveryTabbedCarousel-module__NJooza__slideTitleText",
  "subtitle": "DiscoveryTabbedCarousel-module__NJooza__subtitle",
  "tabButtons": "DiscoveryTabbedCarousel-module__NJooza__tabButtons",
});
